import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import AddIcon from '@mui/icons-material/Add'

const FilterCard = ({ configToEdit, makeNewConfig, paths, filterKey, selectedPath, data, title, checkFiltersOnInput, helperText }) => {
  const items = data ?? []

  const handleChange = (key, value) => {
    makeNewConfig(
      selectedPath.index,
      filterKey,
      items.map((oldData, i) => (i === key ? value : oldData)),
      key
    )
  }

  const handleDelete = (key) => {
    makeNewConfig(selectedPath.index, filterKey, items.filter((_, i) => i !== key))
  }

  const handleAdd = () => {
    const newIndex = items.length
    makeNewConfig(selectedPath.index, filterKey, [...items, ''], newIndex)
    setTimeout(() => document.getElementById(`${filterKey}-${newIndex}`)?.focus(), 100)
  }

  return (
    <Paper
      variant='outlined'
      sx={{ flex: 1, p: 1.5, borderRadius: 2, display: 'flex', flexDirection: 'column' }}
    >
      <Typography variant='subtitle2' color='primary' sx={{ mb: 1, fontWeight: 600 }}>
        {title}
      </Typography>
      {helperText && (
        <Typography variant='caption' sx={{ mb: 0.75, display: 'block', color: 'text.secondary' }}>
          {helperText}
        </Typography>
      )}

      <Box sx={{ maxHeight: 160, overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {configToEdit.filters[selectedPath.index] && items.map((item, key) => (
          <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <TextField
              id={`${filterKey}-${key}`}
              value={item}
              onChange={(e) => handleChange(key, e.target.value)}
              size='small'
              fullWidth
              variant='outlined'
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
            />
            <Tooltip title='Rimuovi' arrow>
              <IconButton
                size='small'
                onClick={() => handleDelete(key)}
                sx={{ color: 'error.main' }}
                aria-label='Rimuovi filtro'
              >
                <DeleteOutlineIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Box>
        ))}
      </Box>

      <Button
        size='small'
        startIcon={<AddIcon />}
        onClick={handleAdd}
        disabled={!paths[selectedPath?.index]?.path?.length}
        sx={{ mt: 1, textTransform: 'none', fontWeight: 500, alignSelf: 'flex-start' }}
      >
        Aggiungi
      </Button>
    </Paper>
  )
}

export default FilterCard
